import { render, staticRenderFns } from "./CommunityManage.vue?vue&type=template&id=1c73ee06&scoped=true&"
import script from "./CommunityManage.vue?vue&type=script&lang=js&"
export * from "./CommunityManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c73ee06",
  null
  
)

export default component.exports